import { render, staticRenderFns } from "./ModeOfPayment.vue?vue&type=template&id=095752eb&scoped=true&"
import script from "./ModeOfPayment.vue?vue&type=script&lang=js&"
export * from "./ModeOfPayment.vue?vue&type=script&lang=js&"
import style0 from "./ModeOfPayment.vue?vue&type=style&index=0&id=095752eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095752eb",
  null
  
)

export default component.exports